<template>
  <Field :name="name" :label="label" :error="error" :required="required">
    <textarea
      class="field"
      :name="name"
      :rows="rows"
      :value="value"
      :disabled="disabled"
      :required="required"
      :class="{ 'mt-1': label }"
      :placeholder="placeholder"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event)"
      @focus="$emit('focus', $event)"
    />
  </Field>
</template>

<script>
import { defineComponent } from "vue";
import Field from "@/components/common/fields/Field";

export default defineComponent({
  emits: ["input", "blur", "focus"],

  components: {
    Field,
  },

  props: {
    name: String,
    rows: Number,
    label: String,
    value: String,
    error: String,
    disabled: Boolean,
    placeholder: String,
  },
});
</script>
